import script from "./VisitRecord.vue?vue&type=script&lang=ts&setup=true"
export * from "./VisitRecord.vue?vue&type=script&lang=ts&setup=true"

import "./VisitRecord.vue?vue&type=style&index=0&id=de44639a&lang=less&scoped=true"

import exportComponent from "D:\\鹿小岚\\crm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de44639a"]])

export default __exports__